import { Component, EventEmitter, inject, Input, Output } from "@angular/core"
import { Router } from "@angular/router"
import { environment } from "src/environments/environment"

import { routes } from "../../../../consts"
import { AuthService } from "../../../services/auth.service"

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false
})
export class HeaderComponent {
  @Input() isMenuOpened!: boolean
  @Output() isShowSidebar = new EventEmitter<boolean>()

  public routers: typeof routes = routes
  private router: Router = inject(Router)
  public auth = inject(AuthService)

  public projectId = environment.firebase.projectId

  public openMenu(): void {
    this.isMenuOpened = !this.isMenuOpened

    this.isShowSidebar.emit(this.isMenuOpened)
  }

  public async signOut() {
    await this.auth.logout()

    await this.router.navigate([this.routers.LOGIN])
  }
}
